import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { C } from "../reporting/reportingStyles";
import { Loader } from "../reporting/ReportingShared";
import { previewPage } from "../../utils/merchantPagesApi";
import { chip, notice } from "./pageStyles";

/**
 * The page exactly as the public URL will serve it: the API renders the unsaved draft with the
 * production renderer and the result is shown in a sandboxed iframe (no scripts, no same-origin).
 */
const PagePreviewModal = ({ isOpen, onClose, merchantId, page, initialLang = "en" }) => {
  const [lang, setLang] = useState(initialLang);
  const [device, setDevice] = useState("mobile");
  const [state, setState] = useState({ loading: false, html: "", warnings: [], errors: [] });

  useEffect(() => { if (isOpen) setLang(initialLang); }, [isOpen, initialLang]);

  useEffect(() => {
    if (!isOpen || !page) return undefined;
    let live = true;
    setState((s) => ({ ...s, loading: true }));
    previewPage({ merchantId: merchantId ? Number(merchantId) : undefined, lang, page }).then((r) => {
      if (!live) return;
      if (r.data) setState({ loading: false, html: r.data.html, warnings: r.data.warnings || [], errors: [] });
      else setState({ loading: false, html: "", warnings: [], errors: r.errors?.length ? r.errors : [r.error] });
    });
    return () => { live = false; };
  }, [isOpen, page, lang, merchantId]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="xl">
      <ModalHeader toggle={onClose}>Preview</ModalHeader>
      <ModalBody style={{ background: C.bg }}>
        <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
          <button type="button" style={chip(lang === "en")} onClick={() => setLang("en")}>English</button>
          <button type="button" style={chip(lang === "ar")} onClick={() => setLang("ar")}>العربية</button>
          <span style={{ width: 16 }} />
          <button type="button" style={chip(device === "mobile")} onClick={() => setDevice("mobile")}>Phone</button>
          <button type="button" style={chip(device === "desktop")} onClick={() => setDevice("desktop")}>Desktop</button>
        </div>

        {state.errors.length > 0 && (
          <div style={notice("error")}>
            This draft would be refused on save:
            <ul style={{ margin: "6px 0 0", paddingLeft: 18 }}>{state.errors.map((e) => <li key={e}>{e}</li>)}</ul>
          </div>
        )}
        {state.warnings.length > 0 && (
          <div style={notice("warning")}>
            <ul style={{ margin: 0, paddingLeft: 18 }}>{state.warnings.map((w) => <li key={w}>{w}</li>)}</ul>
          </div>
        )}

        {state.loading && !state.html ? <Loader /> : state.html ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <iframe
              title="Page preview"
              sandbox=""
              srcDoc={state.html}
              style={{
                width: device === "mobile" ? 390 : "100%",
                height: "70vh",
                border: `1px solid ${C.border}`,
                borderRadius: device === "mobile" ? 24 : 8,
                background: C.white,
                opacity: state.loading ? 0.5 : 1,
              }}
            />
          </div>
        ) : null}
      </ModalBody>
    </Modal>
  );
};

export default PagePreviewModal;
